import React, { useState, useEffect } from "react";
import clsx from "clsx";
import PropTypes from 'prop-types';
import {
  Card,
  Typography,
  makeStyles,
  CardHeader,
  List,
  ListItem,
  ListItemText
} from '@material-ui/core';

import { SIREN_BOARD_ITEM_HEIGHT, SIREN_BOARD_TITLE_HEIGHT } from "config.js";

import firebase from '../../Firebase';
import 'firebase/database';
import {useSelector} from 'react-redux';
import { useIntl } from "react-intl";




// Sensor 등 Device으로부터의 heartbeat를 점검하여, 임계치 초과시에는, 디바이스 점검 상태로 간주함
// 점검 상태는 Device 점검(전원, 파손) 및 네트워크 통신 에러 등으로 취급함.
function DeviceStatusBoard( {className, ...rest}) {

  const classes = useStyles();
  const {formatMessage} = useIntl();

  const [errorCount, setErrorCount] = useState(0);
  const [recoverCount, setRecoverCount] = useState(0);
  const firebaseRootRef = useSelector((store) => store.envSettings.firebaseRootRef)

  useEffect(() => {

    if (firebaseRootRef == null || firebaseRootRef.length == 0) return;

    var dbRef = firebase.database().ref('/dashboard/'+ firebaseRootRef ).child("deviceStatus");

    dbRef.child('onError').on('value', (snapshot) => {
      if (snapshot.exists()){
        setErrorCount( snapshot.val() );
      }
    });


    dbRef.child('onRecover').on('value', (snapshot) => {
      if (snapshot.exists()){
        setRecoverCount( snapshot.val() );
      }
    });

    // dbRef.child('devices').on('value', (snapshot) => {
    //   snapshot.forEach( (childSnapshot ) => {
    //     console.log(childSnapshot.val());
    //     console.log(childSnapshot.val().deviceId);
    //     console.log(childSnapshot.val().diff_time);
    //     console.log(childSnapshot.val().timestamp);
    //   });
    // });

  }, []);


  const datas = [
    {
      label: formatMessage({id:'device_check_target'}),
      value: errorCount,
    },
    {
      label: formatMessage({id:'device_check_clear'}),
      value: recoverCount,
    },

  ];


  return (

    <Card className={clsx(classes.root, className)} {...rest}>

      <CardHeader
        className={classes.title}
        title={formatMessage({id:'device_check_board_title'})}
        titleTypographyProps={{ color: 'inherit',  variant:'h6'}}
      />
      <List>
        {datas.map((data) => (
          <ListItem classes={{ divider: classes.itemDivider}}
            divider
            key={data.label}>

            <ListItemText primary={data.label}
              primaryTypographyProps={{ color: 'textSecondary', variant: 'body1' }}/>
            <Typography color="inherit" variant="h5">{data.value}</Typography>
          </ListItem>
        ))}
      </List>
    </Card>
  );
}


DeviceStatusBoard.propTypes = {
  className: PropTypes.string
};

export default DeviceStatusBoard;



const useStyles = makeStyles((theme) => ({
  root:{
    // marginRight: theme.spacing(-1),
  },
  title: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.siren_symbol.main,
    height:SIREN_BOARD_TITLE_HEIGHT,
    padding: '8px 14px',
  },
  label: {
    marginLeft: theme.spacing(1),
  },
  labelbox: {
    margin: theme.spacing(2),
  },
  current: {
    marginTop: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    // color: theme.palette.secondary.contrastText,
    // backgroundColor: theme.palette.secondary.main,
  },
  itemDivider: {
    height:SIREN_BOARD_ITEM_HEIGHT
  }
}));